import React, { useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import DetailComponent from '../components/Detail';
import data from '../data';

const Detail = () => {
  const { id: paramsId, childId } = useParams();
  const parent = data.find(({ id }) => id === paramsId) || {};
  const detail = parent?.children?.find(({ id }) => id === childId) || {};
  const { icon, title } = parent;
  const {
    icon: childIcon, title: childTitle, content, html,
  } = detail;

  useEffect(() => {
    try {
      window.dataLayer.push({
        title,
        subtitle: childTitle,
      });
    } catch (e) {
      console.log(e.message);
    }
  }, [title, childTitle]);

  if (!title || !childTitle) return <Redirect to="/faq" />;

  return (
    <DetailComponent
      content={content}
      icon={icon}
      subIcon={childIcon}
      subtitle={childTitle}
      title={title}
      html={html}
    />
  );
};

export default Detail;
